import Vue from 'vue';
// eslint-disable-next-line import/no-unresolved
import Plyr from 'plyr';

Vue.component('video-lightbox-component', {
    data() {
        return {
            open: false,
            player: null,
        };
    },

    methods: {
        /**
         * Open the lightbox. The embed is only rendered (and therefore
         * loaded) once `open` is true, so the video never loads until
         * the visitor clicks the poster.
         */
        openVideo() {
            this.open = true;
            document.body.classList.add('video-lightbox-open');
            document.addEventListener('keydown', this.onKeydown);

            this.$nextTick(() => {
                // Move the overlay to <body> so it can never be trapped by an
                // ancestor with a `transform` (which turns into the containing
                // block for position: fixed). Without this the lightbox is not
                // truly fullscreen on the breakpoints where parents are translated.
                if (this.$refs.lightbox) {
                    document.body.appendChild(this.$refs.lightbox);
                }

                // Render the embed through Plyr so the control bar (including a
                // clearly visible fullscreen button) is always shown and never
                // collapses behind Vimeo/YouTube's own responsive overflow menu.
                if (this.$refs.player) {
                    this.player = new Plyr(this.$refs.player, {
                        autoplay: true,
                        ratio: '16:9',
                        controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
                        fullscreen: { enabled: true, fallback: true, iosNative: true },
                    });
                }
            });
        },

        /**
         * Close the lightbox. Destroying the player and removing the embed
         * from the DOM stops playback immediately.
         */
        closeVideo() {
            if (this.player) {
                try {
                    this.player.destroy();
                } catch (e) {
                    // Plyr was already torn down – ignore.
                }
                this.player = null;
            }

            this.open = false;
            document.body.classList.remove('video-lightbox-open');
            document.removeEventListener('keydown', this.onKeydown);
        },

        onKeydown(event) {
            if (event.key === 'Escape' || event.keyCode === 27) {
                this.closeVideo();
            }
        },
    },

    beforeDestroy() {
        if (this.player) {
            try {
                this.player.destroy();
            } catch (e) {
                // ignore
            }
            this.player = null;
        }
        document.removeEventListener('keydown', this.onKeydown);
        document.body.classList.remove('video-lightbox-open');
    },
});
